/* CF Premium — lightweight enhancements (reveal-on-scroll, shop-the-look pins,
   countdown timers). No dependencies, ~2KB. */
(function () {
  'use strict';

  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  onReady(function () {
    /* ---- Reveal on scroll (progressive enhancement) ----
       Content is visible by default. We only switch on the hidden state
       (html.cf-anim) once we know the observer will work, and a safety
       timer guarantees nothing is ever left hidden. */
    var reveals = document.querySelectorAll('.cf-reveal');
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reveals.length && 'IntersectionObserver' in window && !reduceMotion) {
      document.documentElement.classList.add('cf-anim');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            io.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.04 });
      reveals.forEach(function (el) { io.observe(el); });
      var revealAll = function () {
        reveals.forEach(function (el) { el.classList.add('is-visible'); });
      };
      setTimeout(revealAll, 1400);
      window.addEventListener('load', function () { setTimeout(revealAll, 300); });
    }

    /* ---- Shop-the-look pins ---- */
    document.querySelectorAll('.cf-look__pin').forEach(function (pin) {
      pin.addEventListener('click', function (ev) {
        ev.preventDefault();
        var open = pin.getAttribute('aria-expanded') === 'true';
        document.querySelectorAll('.cf-look__pin[aria-expanded="true"]').forEach(function (p) {
          p.setAttribute('aria-expanded', 'false');
        });
        pin.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });
    document.addEventListener('click', function (ev) {
      if (!ev.target.closest('.cf-look')) {
        document.querySelectorAll('.cf-look__pin[aria-expanded="true"]').forEach(function (p) {
          p.setAttribute('aria-expanded', 'false');
        });
      }
    });

    /* ---- Coupon code copy ---- */
    document.querySelectorAll('[data-cf-copy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var val = btn.getAttribute('data-cf-copy') || '';
        var done = function () {
          var t = btn.textContent;
          btn.textContent = 'Copied!';
          setTimeout(function () { btn.textContent = t; }, 1500);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(val).then(done, done);
        } else {
          var ta = document.createElement('textarea');
          ta.value = val; document.body.appendChild(ta); ta.select();
          try { document.execCommand('copy'); } catch (e) {}
          document.body.removeChild(ta); done();
        }
      });
    });

    /* ---- Countdown timers ---- */
    document.querySelectorAll('[data-cf-countdown]').forEach(function (el) {
      var target = el.getAttribute('data-cf-countdown');
      if (!target) return;
      var end = new Date(target).getTime();
      if (isNaN(end)) return;
      var nums = {
        d: el.querySelector('[data-cf-d]'),
        h: el.querySelector('[data-cf-h]'),
        m: el.querySelector('[data-cf-m]'),
        s: el.querySelector('[data-cf-s]')
      };
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var diff = end - Date.now();
        if (diff < 0) diff = 0;
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        if (nums.d) nums.d.textContent = pad(d);
        if (nums.h) nums.h.textContent = pad(h);
        if (nums.m) nums.m.textContent = pad(m);
        if (nums.s) nums.s.textContent = pad(s);
      }
      tick();
      setInterval(tick, 1000);
    });
  });
})();
